import { type FC } from "react";

import { PageLoader } from "@/components/ui";

/**
 * WHAT:
 *   Specialized loader component for Oura pages.
 *
 * WHY:
 *   Uses global PageLoader component with Oura-specific settings.
 *
 * BEHAVIOR:
 *   - Displays loading message "Lade Oura-Daten..."
 *   - Uses large size and backdrop for visibility.
 *
 * @returns JSX element displaying Oura loader.
 *
 */
export const OuraLoader: FC = () => (
  <PageLoader message="Lade Oura-Daten..." size="lg" withBackdrop />
);
